import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConstants } from 'src/app/app.constants';
import { Setting } from 'src/app/shared/models/settings.models';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorHandlerService } from "src/app/core/services/error-handler.service";
// import { Person } from 'shared/models/people';

@Injectable({
  providedIn: 'root'
})
export class BusinessCaseService {

  settingsData = '/assets/mockdata/settingsData.json';
  baseURL: string = "https://localhost:4200/";
  // base_URL = '/assets/mockdata/settingsData.json';
  settingList = [];
  constructor(private http: HttpClient, private router: Router, private errorHandlerService: ErrorHandlerService) {

  }

  getSettings() {
    return this.http.get<any>('/assets/mockdata/settingsData.json')
      .toPromise()
      .then(res => <Setting[]>res.data)
      .then(data => { return data; })
  }

  getBusinessCase(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.BUSINESSCASE.POST}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getUserBusinessCase(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.BUSINESSCASE.USER_POST}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getFutureVolumeGrowth(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT2}${AppConstants.API.BUSINESSCASE.FUTURE_VOLUME_GROWTH}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getMarketShare(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT2}${AppConstants.API.BUSINESSCASE.MARKET_SHARE}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getRldPriceIncrease(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT2}${AppConstants.API.BUSINESSCASE.RLD_PRICE_INCREASE}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getPriceErosion(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT2}${AppConstants.API.BUSINESSCASE.PRICE_EROSION}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getData(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT2}${AppConstants.API.BUSINESSCASE.BUSINESS_CASE}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getCumulativeRevenue(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.BUSINESSCASE.CUMULATIVIE_REVENUE}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getBusinessCase_NA_Data(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.BUSINESSCASE.BUSINESS_CASE_NA}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  updateBusinessCaseData(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.BUSINESSCASE.UPDATE_BUSINESS_CASE}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  updateUserBusinessCaseData(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.BUSINESSCASE.UPDATE_USER_BUSINESS_CASE}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  refreshData(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.BUSINESSCASE.REFRESH_DATA}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
  getBCStrengthUnitPrice(data) {
    return this.http.post(`https://commercial.pharsights.com/api/BusinessCaseIQVIA/bc-strength-unitprice`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  LockBusinessCase(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.BUSINESSCASE.LOCK_BUSINESSCASE}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
}